export const freePackageSupportedLocales = ['en-us'];

export const productKeyToPackagesSorted = [
  {
    // Wix US
    productKey: 'PRD-K3PODM2X4',
    plans: [
      'Business Basic',
      'Business Unlimited',
      'Business VIP',
      'Combo',
      'Unlimited',
      'Pro',
      'VIP',
    ],
  },
  {
    // Wix non-US
    productKey: 'PRD-WK0HCEMQF',
    plans: [
      'Business Basic',
      'Business Unlimited',
      'Business VIP',
      'Connect Domain',
      'Combo',
      'Unlimited',
      'VIP',
    ],
  },
];

export const oldPackagesSorted = [
  'Connect Domain',
  'Combo',
  'Pro',
  'Business Basic',
  'Unlimited',
  'Business Unlimited',
  'VIP',
  'Business VIP',
];

export const newPackagesSorted = [
  'Light',
  'Core',
  'Business',
  'Business Elite',
];

export const freePackage = 'Free';

export const oldToNewPackagesMapped = [
  [newPackagesSorted[0], newPackagesSorted[0]], // Light              -> Light
  [oldPackagesSorted[0], newPackagesSorted[0]], // Connect Domain     -> Light
  [oldPackagesSorted[1], newPackagesSorted[0]], // Combo              -> Light
  [oldPackagesSorted[2], newPackagesSorted[0]], // Pro                -> Light

  [newPackagesSorted[1], newPackagesSorted[1]], // Core               -> Core
  [oldPackagesSorted[3], newPackagesSorted[1]], // Business Basic     -> Core
  [oldPackagesSorted[4], newPackagesSorted[1]], // Unlimited          -> Core

  [newPackagesSorted[2], newPackagesSorted[2]], // Business           -> Business
  [oldPackagesSorted[5], newPackagesSorted[2]], // Business Unlimited -> Business
  [oldPackagesSorted[6], newPackagesSorted[2]], // VIP                -> Business

  [newPackagesSorted[3], newPackagesSorted[3]], // Business Elite     -> Business Elite
  [oldPackagesSorted[7], newPackagesSorted[3]], // Business VIP       -> Business Elite
];

export function isNewPlan(plan: string) {
  return newPackagesSorted.includes(plan);
}

export function getNewPlanName(plan: string) {
  return oldToNewPackagesMapped.find(
    (mappedPlans) => mappedPlans[0] === plan
  )?.[1];
}

export function getLowerPlans(plan?: string) {
  return plan && newPackagesSorted.includes(plan)
    ? newPackagesSorted.slice(0, newPackagesSorted.indexOf(plan))
    : [];
}

export function isEnabledPlan(plan: string, locale: string) {
  if (freePackageSupportedLocales.includes(locale)) {
    return plan === freePackage || isNewPlan(plan);
  }
  return isNewPlan(plan);
}
